







































import { bookGoodsModelProvider } from '../model'
import { defineClassComponent } from '@/hooks'
import { navigateTo } from '@/router'

export default defineClassComponent(
  () =>
    class {
      bookGoodsModel = bookGoodsModelProvider.inject()

      handleGoodsClick = (goodsId: string) => {
        navigateTo('BookGoodsIndex', {
          goodsId: goodsId,
        })
      }
    },
)
